<template>
  <li
    :class="['app-multiselect__option-item', { '--selected': isSelectedItem }]"
    @click="isSelectedItem ? removeItem(item.value) : addItem(item.value)"
  >
    <div :class="['app-multiselect__option-item-content', { '--has-subtext': !!item.subText }]">
      <span class="app-multiselect__option-label">{{ item.text }}</span>
      <span class="app-multiselect__option-sublabel">{{ item.subText }}</span>
    </div>

    <CircleCloseIcon
      class="app-multiselect__option-close-icon"
      v-show="isSelectedItem"
    />
  </li>
</template>

<script>
  import CircleCloseIcon from './icons/CircleCloseIcon.vue';
  export default {
    components: {
      CircleCloseIcon
    },
    computed: {
      isSelectedItem() {
        return this.multiselectRef._data.selectedItemsLocal.includes(this.item.value);
      }
    },
    props: {
      item: {
        type: Object,
        default: () => {}
      },
      multiselectRef: {
        type: Object,
        default: () => {}
      }
    },
    methods: {
      addItem(id) {
        this.multiselectRef._data.selectedItemsLocal.push(id);
      },
      removeItem(id) {
        const index = this.multiselectRef._data.selectedItemsLocal.indexOf(id);
        this.multiselectRef._data.selectedItemsLocal.splice(index, 1);
      }
    }
  };
</script>

<style lang="scss">
  .app-multiselect__container {
    .app-multiselect__option-item {
      display: flex;
      padding: 12px 21px;
      background: #fff;
      cursor: pointer;
      user-select: none;
      gap: 4px;
      align-items: center;

      .app-multiselect__option-item-content {
        width: 100%;
        display: flex;
        flex-direction: column;

        .app-multiselect__option-label {
          color: #998f8a;
          font-family: Raleway;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px;
        }

        &.--has-subtext {
          .app-multiselect__option-label {
            color: #4c4541;
            font-weight: 600;
          }
        }

        .app-multiselect__option-sublabel {
          color: #998f8a;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          font-family: Raleway;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 16px;
        }
      }

      .app-multiselect__option-close-icon {
        min-height: 12px;
        max-height: 12px;
        max-width: 12px;
        min-width: 12px;

        path {
          fill: #fff !important;
        }
      }

      &:hover {
        background: #ffede2;
      }

      &:active {
        background: #ffdbc4;
      }

      &.--selected {
        background: #974900;

        .app-multiselect__option-item-content {
          .app-multiselect__option-label,
          .app-multiselect__option-sublabel,
          span {
            color: #fff;
          }
        }

        svg path {
          fill: #fff;
        }
      }

      &.--disabled {
        background: #eee;

        .app-multiselect__option-label,
        span {
          color: #7e7570;
        }

        svg path {
          fill: #7e7570;
        }
      }

      &:hover,
      &:active {
        .app-multiselect__option-item-content {
          .app-multiselect__option-label,
          .app-multiselect__option-sublabel,
          span {
            color: #974900;
          }
        }

        svg path {
          fill: #974900;
        }

        &.--selected {
          background: #974900;

          .app-multiselect__option-item-content {
            .app-multiselect__option-label,
            .app-multiselect__option-sublabel,
            span {
              color: #fff;
            }
          }

          svg path {
            fill: #fff;
          }
        }
      }
    }
  }
</style>
